<script lang="ts">
	// One item in the segmented pill. Self-styled (no separate Toggle dependency):
	// muted by default, brand-filled when bits-ui marks it data-[state=on].
	// NO arbitrary `[..]` values.
	import { ToggleGroup as ToggleGroupPrimitive } from "bits-ui";
	import type { Snippet } from "svelte";
	import { cn, type WithoutChildren } from "../../../utils.js";

	let {
		ref = $bindable(null),
		value,
		class: className,
		children,
		...restProps
	}: WithoutChildren<ToggleGroupPrimitive.ItemProps> & { children?: Snippet } = $props();
</script>

<ToggleGroupPrimitive.Item
	bind:ref
	{value}
	data-slot="toggle-group-item"
	class={cn(
		"inline-flex shrink-0 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border-none px-3 py-1.5 text-base font-semibold text-muted outline-none transition-colors select-none hover:bg-surface-muted hover:text-ink focus-visible:ring-2 focus-visible:ring-brand data-[state=on]:bg-brand data-[state=on]:text-on-brand [&_svg]:pointer-events-none [&_svg]:shrink-0",
		className
	)}
	{...restProps}
>
	{@render children?.()}
</ToggleGroupPrimitive.Item>
